import { inject, Injectable } from '@angular/core';
import { SquareProductSalesEndpoints } from 'app/core/enums/endpoints/gateway.enum';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';
import { LoadSquareProductSalesQueryParams, SquareProductSalesPayload } from '../../types';

@Injectable({
    providedIn: 'root',
})
export class SquareProductSalesService {
    private _endpoint = SquareProductSalesEndpoints;
    private _apiService = inject(ApiService);

    // ------------------------------------------------------------------
    // @ API methods
    // ------------------------------------------------------------------

    getAll(params: LoadSquareProductSalesQueryParams): Observable<any> {
        return this._apiService.getWithQueryParams(this._endpoint.getAll, params);
    }

    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getOne, id);
    }

    create(data: SquareProductSalesPayload): Observable<any> {
        return this._apiService.post(this._endpoint.create, data);
    }

    update(data: SquareProductSalesPayload, id: number): Observable<any> {
        return this._apiService.update(this._endpoint.update, data, id);
    }

    delete(id: number): Observable<any> {
        return this._apiService.delete(this._endpoint.delete, id);
    }
}
